export function priceDecimals(price) {
    if (price <= 0) return 0;

    const intPart = parseInt(price);
    const decimal = price - intPart;

    if (decimal === 0) {
        return intPart - 0.01;
    }

    if (decimal > 0 && decimal <= 0.50) {
        return intPart + 0.49;
    }

    if (decimal >= 0.51 && decimal <= 0.99) {
        return intPart + 0.99;
    }

    return price;
}

export function formatPrice(price) {
    return '$' + parseFloat(price).toFixed(2);
}
